import React  from 'react';
import PropTypes from 'prop-types';

const UserProfileIcon = (props) => {
  const { width, height, isActive } = props;
  let color;
  if (isActive) {
    color = '#FF4200';
  }
  else {
    color = '#AEB2BF';
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 25 24">
      <path fill={color} d="M23.705 0H1.85a.997.997 0 0 0-.994 1v22c0 .552.446 1 .994 1h21.856a.997.997 0 0 0 .994-1V1c0-.552-.445-1-.994-1zm-.993 22h-1.987c0-3.314-2.669-6-5.961-6H10.79c-3.292 0-5.96 2.686-5.96 6H2.841V2h19.87v20z"/>
      <path fill={color} d="M12.779 14c2.194 0 3.973-1.791 3.973-4V9c0-2.209-1.779-4-3.973-4-2.195 0-3.974 1.791-3.974 4v1c0 2.209 1.779 4 3.974 4z"/>
    </svg>
  );
};

UserProfileIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  isActive: PropTypes.bool,
};

UserProfileIcon.defaultProps = {
  width: 25,
  height: 24,
  isActive: false,
};

export default UserProfileIcon;
